// extracted by mini-css-extract-plugin
export default {"dlNewRF":"src-js-common-components-formatters-CaseHaiRFLinkFormatter---dlNewRF---tsLDw"};